import { useState } from "react"
import "./credentialsPopUp.scss"
import { useNavigate } from "react-router-dom"
import SocialHub from "../socialHub/SocialHub";
import { auth, logAnalyticsEvent } from "../../services/firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";

const CredentialsPopUp = ({currentItem}) => {
    const url = window.location.pathname;
    const navigate = useNavigate();

    const [error, setError] = useState(false);
    const [correct, setCorrect] = useState(false);
    const [loading, setLoading] = useState(false);

    var [password, setPassword] = useState( localStorage.getItem('password') || "");

    const registerView = async (userId, targetUrl) => {
        await logAnalyticsEvent('login', userId, userId, { url: targetUrl });
    }

    const handleLogin = async (e) => {        
        e.preventDefault();
        setError(false);
        setLoading(true);

        try {
            const targetUrl = currentItem ? currentItem.link : url;
            const res = await fetch("/api/verifyPassword", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ password })
            });

            if (res.ok) {
                const data = await res.json();
                
                let hasAccess = false;
                
                // If there's no currentItem passed via the event, or the link is empty it's a generic login from the pill
                const isGlobalLogin = !currentItem || Object.keys(currentItem).length === 0 || !targetUrl || targetUrl === "";
                
                if (isGlobalLogin) {
                    hasAccess = true;
                } else {
                    hasAccess = data.allowed_projects.includes(targetUrl) || data.allowed_projects.includes("/dashboard");
                }

                if (!hasAccess) {
                    setError("You have no access to this project");
                } else {
                    // --- FIREBASE AUTH INTEGRATION (The "Fake Email" trick) ---
                    const fakeEmail = `${password}@accesos.oliviarue.com`;
                    try {
                        // Try to log in
                        await signInWithEmailAndPassword(auth, fakeEmail, password);
                    } catch (authErr) {
                        // If user doesn't exist yet (auto-migration), create it
                        if (authErr.code === 'auth/user-not-found' || authErr.code === 'auth/invalid-credential') {
                            try {
                                await createUserWithEmailAndPassword(auth, fakeEmail, password);
                            } catch (createErr) {
                                console.error("Could not auto-create Firebase user:", createErr);
                            }
                        } else {
                            console.error("Firebase Auth login failed:", authErr);
                        }
                    }
                    // ------------------------------------------------------------

                    localStorage.setItem('password', password);
                    localStorage.setItem('user', data.userName);
                    localStorage.setItem('userId', data.id);
                    localStorage.setItem('allowed_projects', JSON.stringify(data.allowed_projects));
                    
                    setCorrect(true);
                    await registerView(data.id, targetUrl);
                    
                    if (targetUrl && targetUrl !== "" && targetUrl !== url) {
                        navigate(targetUrl);
                    }
                    window.location.reload(true);
                }
            } else {
                setError("Wrong password!");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError("Server error. Please try again later.");
        } finally {
            setLoading(false);
        }
    }

    if (correct) {
        return null;
    } else {
        return (
            <div className="credentialsWindow">
                <h1>
                    <span>Private access</span>
                </h1>

                <form onSubmit={handleLogin}>
                    <input type="password" placeholder=" Password" autoComplete="new-password" onChange={e => setPassword(e.target.value)} />
                    <button type="submit" disabled={loading}>
                        {loading ? "Checking..." : "Access"}
                    </button>
                    {error && <span>{error}</span>}
                    <br/>
                </form>
                <label>Ask me for password:</label>
                <SocialHub alignment="center" />

            </div>
        )
    }
}

export default CredentialsPopUp;